module.exports = __webpack_public_path__ + "img/global-gap.dba6f28d.png";